(ns ycweb.app.website.help.help
  (:require
   [rum.core :as rum]
   [util.string :as str]
   [ycweb.app.website.website :as website]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.help.article]
   [ycweb.app.website.help.categories]
   [ycweb.app.website.help.common :as common]
   [ycweb.app.website.help.faqs]
   [ycweb.app.website.help.results]
   [ycweb.app.website.myaccount.common :as awm.common]
   [ycweb.components.appcommon :as appcommon]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]
   [ycweb.util.shapes :as shapes]))

(rum/defc article-link < rum/reactive [app-atom {:keys [id title url-name deleted]}]
  (when-not deleted
    [:li
     [:a.text-link.text-link--unmarked
      (urlstate/href-props app-atom "help" "article"
        {:title url-name
         :id id})
      title]]))

(rum/defc support-avatar < rum/reactive [{:keys [img firstname lastname]}]
  [:li.avatar-cloud__item
   {:class (u/bem :tooltip [:bottom]) :data-tooltip firstname}
   [:img.avatar
    {:src
     img
     :alt (str firstname " " lastname)
     :class (u/bem :yc-simple-image [:full])}]])


(rum/defc cs-agents < rum/reactive []
  [:div
   {:class (u/bem :yc-section [:medium-underline])}
   (headings/heading
     (list
       "Customer Support contact hours"
       [:span.u-hidden-from-view ":"])
     {:type :h3
      :size :tiny
      :center true})
   [:p.yc-paragraph.u-text-center
    "Monday to Friday - 08h00 to 16h30 | Closed on Saturdays, Sundays and Public Holidays"]
   [:div.u-block-center
    [:ul.avatar-cloud
     (support-avatar
       {:firstname "Shamielah"
        :lastname "Lucas"
        :img "https://res.cloudinary.com/yuppiechef/image/upload/f_auto/v1/pages/help-center/customer-service-team/shamielah-lucas"})
     (support-avatar
       {:firstname "Keenan"
        :lastname "Ruiters"
        :img "https://res.cloudinary.com/yuppiechef/image/upload/f_auto/v1/pages/help-center/customer-service-team/keenan-ruiters"})
     (support-avatar
       {:firstname "Sekai"
        :lastname "Chamhere"
        :img "https://res.cloudinary.com/yuppiechef/image/upload/f_auto/v1/pages/help-center/customer-service-team/sekai-chamhere"})
     (support-avatar
       {:firstname "Eva"
        :lastname "Coetzee"
        :img "https://res.cloudinary.com/yuppiechef/image/upload/f_auto/v1/pages/help-center/customer-service-team/eva-coetzee"})
     (support-avatar
       {:firstname "Tania"
        :lastname "Carr"
        :img "https://res.cloudinary.com/yuppiechef/image/upload/f_auto/v1/pages/help-center/customer-service-team/tania-carr.jpg"})
     (support-avatar
       {:firstname "Michelle"
        :lastname "Klein"
        :img "https://res.cloudinary.com/yuppiechef/image/upload/f_auto/v1/pages/help-center/customer-service-team/michelle-klein.jpg"})
     (support-avatar
       {:firstname "Dillon"
        :lastname "Simons"
        :img "https://res.cloudinary.com/yuppiechef/image/upload/f_auto/v1/pages/help-center/customer-service-team/dillon-simons.jpg"})
     (support-avatar
       {:firstname "Amber"
        :lastname "Riley"
        :img "https://res.cloudinary.com/yuppiechef/image/upload/f_auto/v1/pages/help-center/customer-service-team/amber-riley.jpg"})
     (support-avatar
       {:firstname "Rumbi"
        :lastname "Mahachi"
        :img "https://res.cloudinary.com/yuppiechef/image/upload/f_auto/v1/pages/help-center/customer-service-team/rumbi-malachi.jpg"})
     (support-avatar
       {:firstname "Tashreeq"
        :lastname "Carstens"
        :img "https://res.cloudinary.com/yuppiechef/image/upload/f_auto/v1/pages/help-center/customer-service-team/tashreeq-carstens.jpg"})
     (support-avatar
       {:firstname "Buhle"
        :lastname "Makhunga"
        :img "https://res.cloudinary.com/yuppiechef/image/upload/f_auto/v1/pages/help-center/customer-service-team/buhle-makhunga.jpg"})
     (support-avatar
       {:firstname "Nikita"
        :lastname "Salies"
        :img "https://res.cloudinary.com/yuppiechef/image/upload/f_auto/v1/pages/help-center/customer-service-team/nikita-salies.jpg"})
     (support-avatar
       {:firstname "Aneeqah"
        :lastname "Stober"
        :img "https://res.cloudinary.com/yuppiechef/image/upload/f_auto/v1/pages/help-center/customer-service-team/aneeqah-stober.jpg"})
     (support-avatar
       {:firstname "Thabisa"
        :lastname "Feni"
        :img "https://res.cloudinary.com/yuppiechef/image/upload/f_auto/v1/pages/help-center/customer-service-team/thabisa-feni.jpg"})
     (support-avatar
       {:firstname "Ghakeem"
        :lastname "Geduld"
        :img "https://res.cloudinary.com/yuppiechef/image/upload/f_auto/v1/pages/help-center/customer-service-team/ghakeem-geduld.jpg"})
     (support-avatar
       {:firstname "Cameron"
        :lastname "Jeftha"
        :img "https://res.cloudinary.com/yuppiechef/image/upload/f_auto/v1/pages/help-center/customer-service-team/cameron-jeftha.jpg"})
     (support-avatar
       {:firstname "Melissa"
        :lastname "Petersen"
        :img "https://res.cloudinary.com/yuppiechef/image/upload/f_auto/v1/pages/help-center/customer-service-team/melissa-petersen.jpg"})
     (support-avatar
       {:firstname "Chanelle"
        :lastname "Salies"
        :img "https://res.cloudinary.com/yuppiechef/image/upload/f_auto/v1/pages/help-center/customer-service-team/chanelle-salies.jpg"})]]
   [:div.u-block.u-block-center.u-max-width-240.u-margin-top-24
    (buttons/button-web "Open live chat"
      {:href "/chat.htm?ref=help"
       :style :primary
       :full true
       :icon :chat})]])

(rum/defc help-centre < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        popular-topics (cmn/curact process-atom [:help-centre :help-centre/popular-topics])
        {:help-centre/keys [address suburb city province postal-code]} (cmn/curact process-atom :help-centre)]
    (web-common/set-meta-title! "Yuppiechef Help Centre")

    [:div (common/help-center-banner app-atom {:landing true})
     [:div.yc-section
      [:div
       {:class (u/bem :yc-section [:medium-underline])}
       (headings/heading "Popular help topics" {:type :h2 :size :medium :center true})
       [:div.flex-grid-group
        (map
          (fn [article-column]
            [:div
             {:class (u/bem :flex-grid-block [:ml-1-3])}
             [:div.flex-grid-content
              [:ul.yc-list.u-block-center.u-max-width-320
               (map
                 (fn [{:popular-topic/keys [id url-name] :ent/keys [display-name]}]
                   (article-link app-atom
                     {:title display-name
                      :id id
                      :url-name url-name}))
                 article-column)]]])
          (partition-all 4 popular-topics))]
       [:div.u-block-center.u-max-width-480
        [:div.flex-grid-group
         [:div
          {:class (u/bem :flex-grid-block [:m-order-02 :m-1-2])}
          [:div.flex-grid-content
           (buttons/button-web "View all FAQs"
             (merge
               (urlstate/href-props app-atom "help" "faqs")
               {:style :primary
                :size :default
                :full true}))]]
         [:div
          {:class (u/bem :flex-grid-block [:m-1-2])}
          [:div.flex-grid-content
           (buttons/button-web "Track your order"
             (merge
               (urlstate/href-props app-atom "myaccount" "track")
               {:style :secondary
                :size :default
                :full true}))]]]]]
      [:div
       {:id "help-contact-section"
        :class (u/bem :yc-section [:standard])}
       (headings/heading "Get in touch with a real person"
         {:type :h2 :size :medium :center true})
       [:div
        {:class (u/bem :flex-grid-group [:align-left :flush])}
        [:article
         {:class (u/bem :flex-grid-block [:ml-1-3])}
         [:div.flex-grid-content
          [:a.contact-option.u-block-link.u-bg-peacock
           (urlstate/href-on-click #(grid/dispatch-action app-atom :web.help/contact-popup {}))
           [:div.contact-option__content
            [:h3.contact-option__title "Email Us"]
            [:p.contact-option__description
             "A real human will get back to you"]
            [:div.contact-option__button-wrapper
             [:span.contact-option__button
              {:class
               (u/bem :button [:bordered :secondary :full :default :raised])}
              [:span.button__text "Send email"]]]]]]]
        [:article
         {:class (u/bem :flex-grid-block [:ml-1-3])}
         [:div.flex-grid-content
          [:a.contact-option.u-block-link.u-bg-greenery
           {:href "tel:+278617024969"}
           [:div.contact-option__content
            [:h3.contact-option__title "Call: 0861 702 4969"]
            [:p.contact-option__description "Standard call rates apply"]
            [:div.contact-option__button-wrapper
             [:span.contact-option__button
              {:class
               (u/bem :button [:bordered :secondary :full :default :raised])}
              [:span.button__text "Call us"]]]]]]]
        [:article
         {:class (u/bem :flex-grid-block [:ml-1-3])}
         [:div.flex-grid-content
          [:a.contact-option.u-block-link.u-bg-terracotta
           (urlstate/href-props app-atom "store-directory" nil
             {:ref "helphome"})
           [:div.contact-option__content
            [:h3.contact-option__title "Store Directory"]
            [:p.contact-option__description
             "Location, Trading Hours & Contact"]
            [:div.contact-option__button-wrapper
             [:span.contact-option__button
              {:class
               (u/bem :button [:bordered :secondary :full :default :raised])}
              [:span.button__text "View stores"]]]]]]]]
       [:div.flex-grid-group
        [:article
         {:class (u/bem :flex-grid-block [:ml-1-3])}
         [:div.flex-grid-content
          [:a.u-block-link.u-bg-ghost
           (merge
             {:class (u/bem :contact-option [:alt])}
             (urlstate/href-props app-atom "help" "category"
               {:id 13
                :name "Contact-Enquiries"}))
           [:div.contact-option__content
            [:h3.contact-option__subtitle "PR & Media Queries"]
            [:div.contact-option__button-wrapper
             [:span.contact-option__button
              {:class
               (u/bem :button [:bordered :secondary :full :default :raised])}
              [:span.button__text "View contacts"]]]]]]]
        [:article
         {:class (u/bem :flex-grid-block [:ml-1-3])}
         [:div.flex-grid-content
          [:a.u-block-link.u-bg-ghost
           {:href "tel:+27217024969" :class (u/bem :contact-option [:alt])}
           [:div.contact-option__content
            [:h3.contact-option__subtitle "Cape Town: 021 702 4969"]
            [:div.contact-option__button-wrapper
             [:span.contact-option__button
              {:class
               (u/bem :button [:bordered :secondary :full :default :raised])}
              [:span.button__text "Call us"]]]]]]]
        [:article
         {:class (u/bem :flex-grid-block [:ml-1-3])}
         [:div.flex-grid-content
          [:a.u-block-link.u-bg-ghost
           (merge
             {:class (u/bem :contact-option [:alt])}
             (urlstate/href-props app-atom "help" "category"
               {:id 13
                :name "Contact-Enquiries"}))
           [:div.contact-option__content
            [:h3.contact-option__subtitle "Supplier & Product Queries"]
            [:div.contact-option__button-wrapper
             [:span.contact-option__button
              {:class
               (u/bem :button [:bordered :secondary :full :default :raised])}
              [:span.button__text "View contacts"]]]]]]]]]
      (cs-agents)
      [:div
       {:class (u/bem :yc-section [:large])}
       [:div
        {:class (u/bem :flex-grid-group [:align-left :flush])}
        [:div
         {:class (u/bem :flex-grid-block [:ml-order-02 :ml-2-3])}
         [:div.flex-grid-content
          [:div.google-map-wrapper.u-margin-bottom-10
           [:div.responsive-iframe-wrapper
            {:style {:padding-top "45.4545%"}}
            [:iframe
             {:src "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d423996.5216846735!2d18.1008302!3d-33.8774746!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x32f8bec8663cb3f9!2sYuppiechef.com!5e0!3m2!1sen!2s!4v1492769158471"
              :frameBorder "0"
              :style {:border 0}
              :width "318"
              :height "283"
              :allowFullScreen ""
              :name "fitvid0"}]]]]]
        [:div
         {:class (u/bem :flex-grid-block [:ml-1-3 :s-1-2])}
         [:div.flex-grid-content
          (headings/heading "Head Office" {:type :h3 :size :tiny})
          [:p
           {:class (u/bem :yc-paragraph [:small])}
           (str "Achievement Awards Building, " address) [:br]
           suburb [:br]
           city [:br]
           province [:br]
           postal-code [:br]
           "GPS: -34.07846548652356, 18.443258586838418"]
          (buttons/button-web "Store directory"
            (merge
              (urlstate/href-props app-atom "store-directory")
              {:style :primary
               :size :default}))]]]]
      (toaster/loading-overlay app-atom :web.help)]]))

(defmethod flow/render-screen :web.help [app-atom _]
  (website/screen-wrapper app-atom
    (help-centre app-atom)
    {:pagetype :help
     :hidesearch true}))

(defmethod t/transition-open :web.help [app-atom _ _]
  (toaster/open-overlay app-atom :web.help)
  (comms/ajax-get :web.help/help-centre {}))

(defmethod comms/receive :web.help/help-centre [app-atom {:keys [help-centre]}]
  (swap! (cmn/process-cursor app-atom) assoc
    :help-centre help-centre)
  (toaster/close-overlay app-atom :web.help))

(defmethod grid/action :web.help/contact-popup-submit [app-atom {:keys [captcha-token]} _]
  (let [process-atom (cmn/process-cursor app-atom)
        {:keys [customer-name contact-number email-address query]} (cmn/curact process-atom :help-contact)
        mobile? (cmn/curact app-atom [:mobile?])

        valid-email
        (when (u/presence email-address)
          (re-matches shapes/email-validate (shapes/clean-email email-address)))

        valid-tel (shapes/clean-tel contact-number)]

    (grid/close-modal app-atom)
    (comms/ajax-post :web.help/contact-popup-submit
      {:captcha-token captcha-token
       :help-contact
       #:help-contact
        {:mobile? mobile?
         :customer-name (str/trim customer-name)
         :contact-number (str/trim valid-tel)
         :email-address (str/trim valid-email)
         :query (str/trim query)
         :url (urlstate/current-url)}})

    (grid/open-modal app-atom :web.help/contact-thank-you
      {:config
       {:title "Thank you"
        :max-width 640}})))

(defmethod comms/receive :web.help/contact-popup-submit [app-atom _]
  (swap! (cmn/process-cursor app-atom) dissoc :help-contact))

(rum/defcs contact-popup-body < rum/reactive (cmn/local nil ::node-atom) [local-atom app-atom]
  (let [node-atom (::node-atom local-atom)
        process-atom (cmn/process-cursor app-atom)
        help-contact-atom (rum/cursor process-atom :help-contact)
        {:keys [captcha-site-key]} (cmn/curact app-atom :config)]

    [:div.modal__content
     (headings/heading "Contact us" {:type :h2 :size :small})
     [:div
      [:div.contact-form-wrapper
       {:id "contact_form_container"}
       [:form.form.u-max-width-640
        {:ref (fn [node] (reset! node-atom node))}
        [:div.form-field
         (forms/input "Name: (required)" "e.g. Jane Smith"
           (rum/cursor help-contact-atom :customer-name)
           {:type :user
            :id :name
            :name :name 
            :required? true
            :icon? true})]
        [:div.form-field
         (forms/input "Contact number: (required)" ""
           (rum/cursor help-contact-atom :contact-number)
           {:type :tel
            :id :contact-number
            :name :contact-number
            :required? true
            :icon? true})]
        [:div.form-field
         (forms/input "Email address: (required)" "e.g. jane.smith@domain.com"
           (rum/cursor help-contact-atom :email-address)
           {:type :email
            :id :email
            :name :email
            :required? true
            :icon? true
            :hide-email-helpers true})]
        [:div.form-field
         (forms/textarea "How can we help?"
           (rum/cursor help-contact-atom :query)
           {:id :query
            :name :query})]
        [:div.form-control
         (buttons/button-web "Submit form"
           {:type :button
            :style :primary
            :disabled
            (or
              (not (u/presence (cmn/curact help-contact-atom :customer-name)))
              (not (u/presence (cmn/curact help-contact-atom :contact-number)))
              (not (u/presence (cmn/curact help-contact-atom :email-address)))
              (not (u/presence (cmn/curact help-contact-atom :query))))
            :on-click
            (forms/form-validate node-atom
              #(appcommon/recaptcha app-atom captcha-site-key :web.help/contact-popup-submit {}))})]]
       [:p.yc-paragraph
        "Trouble with the form or prefer to use your own email system?"
        [:br]
        "Customer Service: "
        [:a
         {:href "mailto:hello@yuppiechef.com"
          :class (u/bem :text-link [:muted])}
         "hello@yuppiechef.com"]
        [:br]
        "PR, Media and Marketing: "
        [:a
         {:href "mailto:media@yuppiechef.com"
          :class (u/bem :text-link [:muted])}
         "media@yuppiechef.com"]]]]]))

(defmethod grid/modal-config :web.help/contact-popup [_ _ _]
  {:body-raw contact-popup-body
   :cancel-key :web.help/contact-popup-close
   :modal-type :variable})

(defmethod grid/action :web.help/contact-popup [app-atom]
  (grid/open-modal app-atom :web.help/contact-popup
    {:config
     {:title "Contact us"
      :max-width 640}}))

(defmethod grid/action :web.help/contact-popup-close [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)]
    (swap! process-atom dissoc :help-contact)))

(rum/defc contact-thank-you-body < rum/reactive []
  [:div.yc-popup
   (headings/heading "Thank you" {:type :h2 :size :small})
   [:p.yc-paragraph
    "We've received your message and someone from our Customer Support team will be in touch with you shortly."]])

(defmethod grid/modal-config :web.help/contact-thank-you [_ _ _]
  {:body-raw contact-thank-you-body
   :modal-type :variable})
